export const StarIcon = ({ fill = "F7AD3C", ...rest }) => {
  return (
    <svg
      width="23"
      height="19"
      viewBox="0 0 23 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.88013 2.15918C10.696 5.6617 13.451 8.41626 16.9534 9.23242C13.4511 10.0485 10.6962 12.8034 9.88013 16.3057C9.06396 12.8033 6.3094 10.0483 2.80688 9.23242C6.30956 8.41647 9.06418 5.66185 9.88013 2.15918Z"
        fill={fill}
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M19.113 0.90918C19.4565 2.38323 20.6157 3.54284 22.0896 3.88672C20.6161 4.2305 19.4568 5.38976 19.113 6.86328C18.7692 5.3894 17.6096 4.23015 16.1355 3.88672C17.6099 3.54318 18.7695 2.38359 19.113 0.90918Z"
        fill={fill}
        stroke="white"
        strokeWidth="0.210491"
      />
      <path
        d="M19.113 11.6011C19.4565 13.0751 20.6157 14.2347 22.0896 14.5786C20.6161 14.9224 19.4568 16.0817 19.113 17.5552C18.7692 16.0813 17.6096 14.922 16.1355 14.5786C17.6099 14.2351 18.7695 13.0755 19.113 11.6011Z"
        fill={fill}
        stroke="white"
        strokeWidth="0.210491"
      />
    </svg>
  );
};
